import { OrderType, TrackingApi } from 'api/TrackingApi';

interface IProps {
  orderType?: OrderType;
  orderId?: string;
}

export const usePayment3dsPopupTracking = ({ orderType, orderId }: IProps) => {
  const track3dsPopupMount = () => {
    if (orderType && orderId) {
      TrackingApi.track3dsVerifyShow({
        orderId,
        orderType,
      }).catch((err) => err);
    }
  };

  const track3dsPopupSubmit = () => {
    if (orderType && orderId) {
      TrackingApi.track3dsVerifyClick({
        orderId,
        orderType,
      }).catch((err) => err);
    }
  };

  const track3dsPopupClose = () => {
    if (orderType && orderId) {
      TrackingApi.track3dsVerifyClose({
        orderId,
        orderType,
      }).catch((err) => err);
    }
  };

  return {
    track3dsPopupMount,
    track3dsPopupSubmit,
    track3dsPopupClose,
  };
};
